import { createAction } from 'utils/redux';

import { FETCH_AGGREGATIONS, RECEIVE_AGGREGATIONS } from './types';

export const fetchAggregations = createAction(FETCH_AGGREGATIONS);
export const receiveAggregations = createAction(RECEIVE_AGGREGATIONS);
